const getproductrequest="getproductrequest";
const getproductfailure="getproductfailure";
const getproductsuccess="getproductsuccess";
const addtocartsuccess="addtocartsuccess";
export {getproductrequest, getproductfailure, getproductsuccess,addtocartsuccess}